import { FindParamsDefault } from './find-params-default';

export interface FindStoreParams extends FindParamsDefault {
  charity_id?: string;
  'address.state'?: string;
}
